import React from "react";
import { Info } from "lucide-react";

export const DemoBadge = ({ label = "Demo Data", testid = "demo-badge" }) => (
  <span className="tag-demo" data-testid={testid}>
    <Info size={11} /> {label}
  </span>
);

export default DemoBadge;
